import React, { useState } from "react";
import { RefreshCw, ExternalLink } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const STYLES = {
  shipped: ["In transit", "#4CC9F0"], fulfilled: ["Shipped", "#4CC9F0"], partial: ["Partly shipped", "#4CC9F0"],
  inprocess: ["In production", "#FFD93D"], in_production: ["In production", "#FFD93D"], pending: ["Sent to print partner", "#FFD93D"],
  draft: ["Draft at print partner", "#FFD93D"], processing: ["Submitting…", "#FFD93D"],
  onhold: ["On hold", "#FF6B9D"], on_hold: ["On hold", "#FF6B9D"], failed: ["Failed", "#FF6B9D"],
  canceled: ["Cancelled", "#FF6B9D"], returned: ["Returned", "#FF6B9D"], missing_address: ["Missing address", "#FF6B9D"],
  not_required: ["No POD items", "#19324A33"], delivered: ["Delivered", "#7ED957"],
};

export default function FulfillmentCell({ order, onRefreshed }) {
  const [busy, setBusy] = useState(false);
  const s = order.fulfillment_status;
  if (!s) return <span className="text-[#19324A]/40" data-testid={`order-fulfillment-${order.order_number}`}>—</span>;
  const [label, colour] = STYLES[s] || [s.replace(/_/g, " "), "#A78BFA"];
  const track = (order.tracking || []).find((t) => t.tracking_url || t.tracking_number);
  const partner = "Printify";

  const refresh = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/admin/orders/${order.order_number}/refresh-fulfillment`); toast.success(`${partner} says: ${data.fulfillment_status}`); onRefreshed?.(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`order-fulfillment-${order.order_number}`}>
      <span className="px-2.5 py-1 rounded-full text-xs font-bold text-[#19324A] whitespace-nowrap" style={{ background: colour.length === 9 ? colour : `${colour}40` }} data-testid={`fulfillment-badge-${order.order_number}`}>{label}</span>
      {track && (
        track.tracking_url
          ? <a href={track.tracking_url} target="_blank" rel="noreferrer" className="text-xs font-bold text-[#4CC9F0] inline-flex items-center gap-1" data-testid={`order-tracking-${order.order_number}`}><ExternalLink className="w-3 h-3" />{track.tracking_number || "Track"}</a>
          : <span className="text-xs text-[#19324A]/60">{track.tracking_number}</span>
      )}
      {order.printify_order_id && (
        <button type="button" onClick={refresh} disabled={busy} aria-label={`Refresh from ${partner}`} title={`Refresh from ${partner}`} data-testid={`order-refresh-${order.order_number}`}
          className="p-1 rounded-lg hover:bg-[#4CC9F0]/15 disabled:opacity-40"><RefreshCw className={`w-3.5 h-3.5 text-[#4CC9F0] ${busy ? "animate-spin" : ""}`} /></button>
      )}
      {order.fulfillment_error && <span className="text-[10px] text-[#FF6B9D] max-w-[200px] truncate" title={order.fulfillment_error}>{order.fulfillment_error}</span>}
    </div>
  );
}
